import React from "react";

const OutputDetails = ({ outputDetails }) => {
  return (
    <div className={`metrics-container flex flex-row space-x-1`}>
      <p className="text-sm">
        Status:{" "}
        <span className="font-semibold px-2 py-1 rounded-md bg-gray-100 text-black">
          {outputDetails?.status?.description}
        </span>
      </p>
      <p className="text-sm">
        Memory:{" "}
        <span className="font-semibold px-2 py-1 rounded-md bg-gray-100 text-black">
          {outputDetails?.memory}
        </span>
      </p>
      <p className="text-sm">
        Time:{" "}
        <span className="font-semibold px-2 py-1 rounded-md bg-gray-100 text-black">
          {outputDetails?.time}
        </span>
      </p>
    </div>
  );
};

export default OutputDetails;
